var _path, _g, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlood(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3225_16738",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 31,
    width: 101,
    height: 95
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.6171 31.6599C75.9933 30.9527 77.0067 30.9527 77.3829 31.6599L126.381 123.78C126.735 124.446 126.252 125.25 125.498 125.25H27.5021C26.7476 125.25 26.2649 124.446 26.6192 123.78L75.6171 31.6599Z",
    fill: "#D8B4B4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3225_16738)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3225_16738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.3726 88.3657L57.7074 81.3666V65.6764C57.7074 65.3177 57.8078 65.0227 58.0094 64.7918C58.2093 64.5612 58.4662 64.4459 58.7793 64.4459H63.2463C63.5591 64.4459 63.8159 64.5612 64.0171 64.7918C64.2178 65.0227 64.3181 65.3178 64.3181 65.6764V75.8487L74.4543 65.3299C75.168 64.6633 76.0167 64.3301 76.9993 64.3301C77.9818 64.3301 78.8303 64.6633 79.5448 65.3299L103.628 88.3657C103.851 88.5704 103.973 88.846 103.996 89.1922C104.019 89.5381 103.941 89.8402 103.762 90.0964L101.685 92.9422C101.506 93.1728 101.272 93.3139 100.982 93.3655C100.714 93.3913 100.446 93.3013 100.178 93.0963L77 70.9063L53.822 93.0962C53.643 93.2751 53.4089 93.3644 53.1186 93.3644H53.0179C52.7281 93.3137 52.4944 93.1718 52.3145 92.9417L50.2377 90.0963C50.0591 89.8395 49.9809 89.5379 50.0041 89.1916C50.027 88.8464 50.1498 88.5708 50.3726 88.3657Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.2589 88.9742L77.0001 70.7451L57.7406 88.9742C57.719 89.0244 57.7068 89.1017 57.7068 89.2041V107.663C57.7068 108.33 57.9197 108.907 58.344 109.393C58.7677 109.881 59.2707 110.125 59.8512 110.125H72.7123V110H79.1774V110.125H94.149C94.7296 110.125 95.232 109.88 95.6562 109.393C96.0805 108.907 96.2927 108.329 96.2927 107.663V89.2041C96.2927 89.1777 96.2869 89.1405 96.2758 89.0893C96.2646 89.0377 96.2589 88.9999 96.2589 88.9742ZM83 90H91V98H83V90Z",
    fill: "#333333"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 102,
    width: 110,
    height: 28,
    fill: "#0099FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 98.4891C20 98.4891 26.0309 102.42 31.75 100.722C37.3686 99.0531 39.4514 97.6152 45.5 97.6152C51.5486 97.6152 53.2014 100.106 59.25 100.722C65.2986 101.337 66.9514 97.6152 73 97.6152C79.0486 97.6152 80.7013 100.722 86.75 100.722C92.7986 100.722 94.4514 97.6152 100.5 97.6152C106.549 97.6152 108.209 100.502 114.25 100.722C119.969 100.93 126 97.7439 126 97.7439V102.212C126 102.212 119.969 105.397 114.25 105.189C108.209 104.97 106.549 102.083 100.5 102.083C94.4514 102.083 92.7986 105.189 86.75 105.189C80.7013 105.189 79.0486 102.083 73 102.083C66.9514 102.083 65.2986 105.189 59.25 105.189C53.2014 105.189 51.5486 102.083 45.5 102.083C39.4514 102.083 37.3686 103.521 31.75 105.189C26.0309 106.888 20 102.957 20 102.957V98.4891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 106.489C20 106.489 26.0309 110.42 31.75 108.722C37.3686 107.053 39.4514 105.615 45.5 105.615C51.5486 105.615 53.2014 108.106 59.25 108.722C65.2986 109.337 66.9514 105.615 73 105.615C79.0486 105.615 80.7013 108.722 86.75 108.722C92.7986 108.722 94.4514 105.615 100.5 105.615C106.549 105.615 108.209 108.502 114.25 108.722C119.969 108.93 126 105.744 126 105.744V110.212C126 110.212 119.969 113.397 114.25 113.189C108.209 112.97 106.549 110.083 100.5 110.083C94.4514 110.083 92.7986 113.189 86.75 113.189C80.7013 113.189 79.0486 110.083 73 110.083C66.9514 110.083 65.2986 113.189 59.25 113.189C53.2014 113.189 51.5486 110.083 45.5 110.083C39.4514 110.083 37.3686 111.521 31.75 113.189C26.0309 114.888 20 110.957 20 110.957V106.489Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.618 14.6507C75.9947 13.9457 77.0053 13.9457 77.382 14.6507L140.233 132.279C140.589 132.945 140.106 133.75 139.351 133.75H13.6492C12.894 133.75 12.4113 132.945 12.7672 132.279L75.618 14.6507Z",
    stroke: "#333333",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3225_16738"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 62,
    fill: "white",
    transform: "matrix(-1 0 0 1 104 58)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlood);
export default __webpack_public_path__ + "static/media/flood.84d8349276b2274f4640d140ca2ca546.svg";
export { ForwardRef as ReactComponent };